import React from "react";

import { Trans, useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { TSection } from "@data-types/offer/live/Section";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { observer } from "mobx-react";

import { SportsAndStatisticsLink } from "./SportsAndStatisticsLink";

export default observer(function LiveEmptyState(props: {
	period: string;
	totalEventCountEmpty?: number;
}) {
	const params = useParams<{ culture: string }>();

	const t = useTranslation().t;

	let icon = "live-highlights",
		title,
		message;
	let link: {
		path: string;
		message: string | JSX.Element;
	} = { path: "", message: "" };
	switch (props.period) {
		case "upcoming":
			icon = "upcoming";
			title = t("LIVE.UPCOMING.EMPTY_TITLE");
			message = t("LIVE.UPCOMING.NO_EVENTS");
			link.path = `/${params.culture}/${DefaultPath.LIVE}`;
			link.message = t("SPORTS.GO_LIVE_BETTING");
			break;
		case "highlights":
			icon = "live-highlights";
			title = t("HOME.LIVE_HIGHLIGHTS.EMPTY.SUBTITLE");
			message = t("HOME.LIVE_HIGHLIGHTS.EMPTY.DESCRIPTION");
			link.path = `/${params.culture}/${DefaultPath.LIVE}`;
			link.message = t("SPORTS.GO_LIVE_BETTING");
			break;
		case TSection.MyFavoritesTournaments:
		case TSection.MyFavoritesEvents:
			icon = "live-highlights";
			title = t(
				props.period === TSection.MyFavoritesTournaments
					? "LIVE.FAVORITES.NO_FAVORITE_LEAGUES"
					: "LIVE.FAVORITES.NO_FAVORITE_EVENTS"
			);
			message = (
				<Trans
					i18nKey={
						props.period === TSection.MyFavoritesTournaments
							? "LIVE.FAVORITES.TOURNAMENT_EMPTY_STATE_MESSAGE"
							: "LIVE.FAVORITES.EVENTS_EMPTY_STATE_MESSAGE"
					}
					components={[
						<i
							key={1}
							className="offer__favorites__icon u-icon u-icon--med u-icon--favorite--alt u-color--sent--muted"
						/>,
						<i
							key={2}
							className="offer__favorites__icon u-icon u-icon--med u-icon--favorite--bold u-color--sent--warning"
						/>,
					]}
				/>
			);
			if (props.totalEventCountEmpty) {
				link.path = `/${params.culture}/sports/full`;
				link.message = t("LIVE.GO_SPORTS_BETTING");
			} else {
				link.path = `/${params.culture}/${DefaultPath.LIVE}`;
				link.message = t("SPORTS.GO_LIVE_BETTING");
			}
			break;
		default:
			icon = "live-highlights";
			title = t("LIVE.NO_LIVE_EVENTS");
			message = t("LIVE.UPCOMING.NO_EVENTS");
			link.path = `/${params.culture}/sports/full`;
			link.message = t("LIVE.GO_SPORTS_BETTING");
			break;
	}

	return (
		<div className="l--content__main u-padd--y--xsml">
			<div className="container">
				<div className="row">
					<div className="col col-sml-12 u-mar--bottom--xsml">
						<div className="card--empty card--shadowy u-mar--bottom--reset">
							<div className="card--empty__content">
								<i
									className={
										"card--empty__icon u-icon u-icon--huge u-icon--empty--" +
										icon
									}
								/>
								<div className="card--empty__title">
									{title}
								</div>
								<div className="card--empty__message">
									{message}
								</div>
								<Link
									to={link.path}
									className="card--empty__btn btn btn--sml btn--primary--inverted btn--icon btn--animate-forward"
								>
									{link.message}
									<i className="u-icon u-icon--tny u-icon--arrow-right" />
								</Link>
							</div>
						</div>
					</div>

					{props.totalEventCountEmpty ? (
						<SportsAndStatisticsLink />
					) : null}
				</div>
			</div>
		</div>
	);
});
